import { BACK_TO_START_SCREEN, BackToStartScreen } from "./appState";
import { RequestStatus } from "./requestStatus";

interface ExistingDischarges {
  status: RequestStatus;
  failedMessage: string;
}

const INITIAL_STATE: ExistingDischarges = {
  status: "NOT_SENT",
  failedMessage: "",
};

const SET_STATUS = "existingDischarges/SET_STATUS";

interface SetStatus {
  type: typeof SET_STATUS;
  failedMessage: string;
  status: RequestStatus;
}

export const setStatus = (message: string, status: RequestStatus) => {
  return {
    type: SET_STATUS,
    failedMessage: message,
    status: status,
  };
};

type ExistingRainMenuAction = SetStatus | BackToStartScreen;

export default function reducer(state = INITIAL_STATE, action: ExistingRainMenuAction) {
  switch (action.type) {
    case BACK_TO_START_SCREEN:
      return INITIAL_STATE;
    case SET_STATUS: {
      const { status, failedMessage } = action;
      return {
        ...state,
        status,
        failedMessage,
      };
    }
    default:
      return state;
  }
}
